"use client";
import * as React from 'react';

type Props = React.InputHTMLAttributes<HTMLInputElement>;

export function Input({ className = '', ...rest }: Props) {
  const cls = ['admin-input', className].filter(Boolean).join(' ');
  return <input className={cls} {...rest} />;
}

export default Input;

